import { render, staticRenderFns } from "./cra.vue?vue&type=template&id=3c38a6a6&scoped=true&"
import script from "./cra.vue?vue&type=script&lang=js&"
export * from "./cra.vue?vue&type=script&lang=js&"
import style0 from "./cra.vue?vue&type=style&index=0&id=3c38a6a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c38a6a6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAutocomplete,VCol,VRow})
